import { type AppTabKey } from '../AppRoute';
import { atom } from 'jotai';

export const tabAtom = atom<AppTabKey | undefined>(undefined);
